import { render, staticRenderFns } from "./SystemMessageView.vue?vue&type=template&id=7caace36&scoped=true"
import script from "./SystemMessageView.vue?vue&type=script&lang=js"
export * from "./SystemMessageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7caace36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7caace36')) {
      api.createRecord('7caace36', component.options)
    } else {
      api.reload('7caace36', component.options)
    }
    module.hot.accept("./SystemMessageView.vue?vue&type=template&id=7caace36&scoped=true", function () {
      api.rerender('7caace36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/systemmessage/SystemMessageView.vue"
export default component.exports